import React from 'react';
import { languageOptions } from '@app/constants';
import i18n from '@app/i18n';
import { QuestionTranslationView } from '@data/sdk/match';
import { AntdTooltip } from '@ui/components';

export const getLanguageOptions = (translations?: QuestionTranslationView[]) => {
  return languageOptions().map((lang) => {
    const isAIGenerated = !!translations?.find((el) => el.language === lang.value)?.isAiGenerated;
    return {
      label: (
        <div className="flex flex-nowrap gap-1 items-center">
          <span>{lang.label}</span>
          {isAIGenerated && (
            <AntdTooltip title={i18n.t('common.ai_translation')}>
              <div className="h-fit px-[3px] py-[2px] border-solid border-inherit border-[1px] text-inherit rounded-full leading-none text-[10px]">
                AI
              </div>
            </AntdTooltip>
          )}
        </div>
      ),
      value: lang.value,
    };
  });
};
